import { createSelector } from 'reselect';
import { buildChannelString } from '@atlassian/jira-realtime/src/common/utils/pubsub.utils.tsx';
import { getCloudId, getProjectIds } from '../app';

export const realtimeChannelsSelector = createSelector(
	getCloudId,
	getProjectIds,
	(cloudId, projectIds) => projectIds.map((projectId) => buildChannelString(cloudId, projectId)),
);
